import type { Licence } from "~/types/licence"

export function isActive(licence: Licence) {
  // TODO: Should this check startDate as well?
  return new Date(licence.endDate) > new Date()
}
